import classNames from "classnames";
import Heading from "../../../../../core/ui/Heading.component";
import "./CoastSubscriptionIntro.style.scss";

const REGULAR_COPY = "Sign up to become a Coast Insider and listen to the show live or on-demand ";
const GIFT_COPY = "Give the gift of Coast Insider - the only way to listen to Coast to Coast AM ";

export const CoastSubscriptionIntro = ({ isGift, isLeftBlock = false }: { isGift: boolean; isLeftBlock?: boolean }) => {
  const className = classNames("component-coast-subscription-intro", { "left-block": isLeftBlock });
  return (
    <section className={className}>
      <div className="intro-header">
        <Heading level={1}>
          {isGift ? "Give the gift of" : "Subscribe to"}
          <br /> Coast Insider
        </Heading>
        <div className="coast-logo" />
      </div>

      <p>
        {isGift ? GIFT_COPY : REGULAR_COPY}
        on your computer or mobile device. All audio streams are delivered in high quality, crystal clear audio.
      </p>

      <Heading className="benefits-title" level={4}>
        All Coast Insider benefits:
      </Heading>
      <ul className="benefits">
        <li>Last seven years of audio archives on our website</li>
        <li>Audio streaming or downloadable MP3s of show archives</li>
        <li>Media access through website or mobile app</li>
        <li>
          Access to the Art Bell Vault,
          <br />a curated collection of vintage shows
        </li>
        <li>Podcast available on Apple Podcasts</li>
        <li>Direct e-mail to main show host</li>
      </ul>

      <div className="host-image" />

      {!isLeftBlock ? <hr className="divider" /> : null}
    </section>
  );
};
